import * as React from "react";
import { ProspectResponse } from "@/interfaces";
import { PlayersServices } from "@/services";
import UserTable from "../../UserTable";
import { Table } from "@/components/ui";
import { printDate } from "@/utils";

const AdminProspectListFC: React.FC = () => {
  return (
    <UserTable
      headers={[{ title: "Email" }, { title: "Created Date" }, { title: "Referral Code" }]}
      queryFunction={query => {
        return PlayersServices.searchAdminProspects(query.searchTerm, query.page, query.size);
      }}
      renderRow={(prospect: ProspectResponse) => (
        <>
          <Table.Cell className="py-3">{prospect.email}</Table.Cell>
          <Table.Cell className="py-3">{printDate(prospect.createdDate!)}</Table.Cell>
          <Table.Cell className="py-3">{prospect.sharedLinkId}</Table.Cell>
        </>
      )}
    />
  );
};

export const AdminProspectList = AdminProspectListFC;
